enum EnumEventStatus {
    NEW = 'NEW',
    ACTIVE = 'ACTIVE',
    CANCELED = 'CANCELED',
    FINISHED = 'FINISHED',
}

export default EnumEventStatus;
